import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'VOUCHER_MODO_TELA',
        payload: {
            modo: modo,
            registro: {
                ...registro,

            }
        }
    };
}
export function initForm(registro = {}) {
    return [
        initialize('voucherForm', {
            ...registro
        })
    ];
}

export function setAguardando(aguardando) {
    return {
        type: 'VOUCHER_SET_AGUARDANDO',
        payload: aguardando
    };
}


export function salvar(registro) {
    console.log(registro);
    return (dispatch, getState) => {
        if (!registro.id) {
            axios.post(`${consts.API_URL}/voucher`, {
                ...registro
            }).then(resp => {
                setSuccess('Operação Realizada com sucesso.');
                dispatch(getLista());
                dispatch(setModoTela('lista'));
            }).catch(e => {
                setErroAPI(e);
            });
        } else {
            axios.put(`${consts.API_URL}/voucher`, {
                ...registro
            }).then(resp => {
                setSuccess('Operação Realizada com sucesso.');
                dispatch(getLista());
                dispatch(setModoTela('lista'));
            }).catch(e => {
                setErroAPI(e);
            });
        }
    };
}

export function excluir(registro) {
    return dispatch => {
        axios.delete(`${consts.API_URL}/voucher?id=${registro.id}`)
            .then(resp => {
                setSuccess('Operação Realizada com sucesso.');
                dispatch(getLista());
                dispatch(setModoTela('lista'));
            }).catch(e => {
                setErroAPI(e);
            });
    };
}

export function getLista() {

	return (dispatch, getState) => {

		dispatch({
			type: 'VOUCHER_LISTADO',
			payload: { data: [] }
		});

		let dataInicial = DateFormat.formatarDataTelaParaParametro(getState().voucher.filtro.dataInicial);
		let dataFinal = DateFormat.formatarDataTelaParaParametro(getState().voucher.filtro.dataFinal);


		dataInicial = dataInicial && dataInicial == 'Invalid DateTime' ? null : dataInicial;
		dataFinal = dataFinal && dataFinal == 'Invalid DateTime' ? null : dataFinal;

        axios.get(`${consts.API_URL}/voucher?
				data_inicial=${dataInicial}
				&data_final=${dataFinal}
                &status=${getState().voucher.filtro.status}
			`).then(resp => {
            dispatch({
                type: 'VOUCHER_LISTADO',
                payload: resp
            });
        }).catch(ex => {

        });
    };
}

export function setFiltro(filtro) {
    console.log(filtro);
    return {
        type: 'VOUCHER_FILTRO',
        payload: filtro
    };
}